<template>
  <v-app>
    <TopBar
      style="left: 0 !important; z-index: 100"
      class="absolute"
      @open-drawer="onOpenDrawer"
    />
    <!-- <NavBar style="left: 0px !important" class="defaultNavBar" /> -->
    <v-navigation-drawer
      v-model="drawer"
      app
      left
      style="top: 62px; background: #f5f5f5; border-top: solid 1px #e4e5e7"
      @transitionend="onOpenDrawer"
    >
      <SideMenu />
    </v-navigation-drawer>
    <div />
    <v-main style="padding-top: 0">
      <v-container
        app
        background-color="grey lighten-2"
        class="default-container pa-0"
      >
        <Message />
        <TrialBanner />
        <router-view />
        <SubmitFormErrorPopup />
        <UpgradeSubscriptionPlanPopup />
        <ZendeskSupportChat />
        <Footer />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Message from '@/components/Message'
import SubmitFormErrorPopup from '@/components/popup/SubmitFormErrorPopup'
import UpgradeSubscriptionPlanPopup from '@/components/popup/UpgradeSubscriptionPlanPopup'
import TopBar from '@/components/top-bar/TopBar'
import SideMenu from '@/components/side-menu/SideMenu'
import TrialBanner from '@/components/subscription/TrialBanner'
import ZendeskSupportChat from '../components/external/js-script/ZendeskSupportChat'
import Footer from '@/views/Footer'
export default {
  name: 'Default',
  components: {
    ZendeskSupportChat,
    TopBar,
    SideMenu,
    Message,
    SubmitFormErrorPopup,
    UpgradeSubscriptionPlanPopup,
    TrialBanner,
    Footer
  },
  data() {
    return {
      drawer: false,
      isMobile: false
    }
  },
  mounted() {
    this.onResize()
  },
  methods: {
    onOpenDrawer(isOpen) {
      this.drawer = !this.drawer
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      if (this.windowSize.x < 1264) this.drawer = false
      else this.drawer = true
    }
  }
}
</script>
<style scoped>
.container {
  width: 100% !important;
  max-width: 100%;
}
::v-deep .defaultNavBar header {
  left: 0px !important;
  width: 100%;
}
</style>
